import { t } from "@lingui/macro";
import { PreviewAndDownloadCell } from "@src/components/widgets/TableCell";
import { observer } from "mobx-react-lite";
import type { ColumnProps } from ".";

export const Documents = observer<ColumnProps>(function Invoice({ row }) {
  const proforma = row.invoicePdf;
  const invoices = row.proofOfPayments;

  return (
    <PreviewAndDownloadCell
      value={[
        {
          label: t`Proforma invoice`,
          value: proforma,
        },
        ...(invoices?.map((invoice) => ({
          label: `${t`Payment receipt`} ${invoice.invoice_no}`,
          value: invoice.invoicePdf,
        })) ?? []),
      ]}
    />
  );
});
